module.exports = __webpack_public_path__ + "img/order.491c0cc4.png";